import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../constants';
import { DateField } from '../../ui/date-field';
import FieldDescription from '../../ui/field-description';
import { useFieldValidation } from '../../contexts/field-validation-context';
import FieldLabel from '../../ui/field-label';
import FieldError from '../../ui/field-error';
import { useError } from '../../field-error';
import { getInputId, getLabelId, getDescriptionId, getErrorId, getAriaDescribedBy } from '../../services/field-attributes';
import { getDateFieldError, getDatePartsErrors, getDateValidatioErrorSuffix } from '../../ui/date-field/date-field-utils';
const DateInput = props => {
  const {
    id,
    description,
    validation,
    target,
    value,
    onChange,
    path,
    error,
    required,
    label,
    hideLabel,
    FieldLayout
  } = props;
  const {
    validateFields
  } = useFieldValidation();
  const dateFieldError = getDateFieldError(validation, error, value);
  const {
    errorMessage,
    hasError
  } = useError(dateFieldError, undefined, FIELD_TYPES.DATE_INPUT, getDateValidatioErrorSuffix(dateFieldError));
  const inputId = getInputId(id);
  const labelId = getLabelId(id);
  const descriptionId = getDescriptionId(id);
  const errorId = getErrorId(id);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabel, {
      labelId: labelId,
      required: required,
      label: label,
      hideLabel: hideLabel
    }),
    renderInput: () => /*#__PURE__*/React.createElement(DateField, _extends({}, props, {
      errors: getDatePartsErrors(hasError, dateFieldError, value),
      inputId: inputId,
      onBlur: handleBlur,
      onChange: handleChange,
      ariaLabelledBy: labelId,
      ariaDescribedBy: getAriaDescribedBy(errorId, descriptionId)
    })),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldError, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescription, {
      description: description,
      id: descriptionId
    }))
  });
  function handleBlur() {
    if (path) {
      validateFields == null || validateFields({
        value,
        path
      });
    }
  }
  function handleChange(newValue) {
    onChange == null || onChange(newValue);
    if (path && hasError) {
      validateFields == null || validateFields({
        path,
        value: newValue
      });
    }
  }
};
DateInput.displayName = 'DateInput';
export default DateInput;
//# sourceMappingURL=date-input.js.map